import { createSelector } from "reselect";

const selectSection = (state) => state.section;

export const selectAllSection = createSelector(
  [selectSection],
  (section) => section.allSection
);

export const selectAllSectionLoading = createSelector(
  [selectSection],
  (section) => section.isLoadingAllSection
);

export const selectSingleSectionLoading = createSelector(
  [selectSection],
  (section) => section.isLoadingSingleSection
);

export const selectIsEditingSection = createSelector(
  [selectSection],
  (section) => section.isEditingSection
);

export const selectIsCreatingSection = createSelector(
  [selectSection],
  (section) => section.isCreatingSection
);

export const selectEditData = createSelector(
  [selectSection],
  (section) => section.editData
);

export const selectCurrentSection = createSelector(
  [selectSection],
  (section) => section.singleSection
);

export const selectIsDeletingSection = createSelector(
  [selectSection],
  (section) => section.isDeletingSection
);
